import { HTMLProps, forwardRef } from 'react';

import classNames from 'classnames';

import { useSectionContext } from './SectionContext';

import styles from './SectionContent.module.css';

export type SectionContentProps = HTMLProps<HTMLDivElement>;

const SectionContent = forwardRef<HTMLDivElement, SectionContentProps>(
  (props, ref) => {
    const { className, children, ...rest } = props;
    const { expanded } = useSectionContext();

    return (
      <div className={styles.collapse} data-expanded={expanded || undefined}>
        <div
          ref={ref}
          className={classNames(className, styles.content)}
          {...rest}
        >
          {children}
        </div>
      </div>
    );
  },
);

SectionContent.displayName = 'Section.Content';

export default SectionContent;
